import { render, staticRenderFns } from "./DerbyRaceList.vue?vue&type=template&id=92ad8330&"
import script from "./DerbyRaceList.vue?vue&type=script&lang=js&"
export * from "./DerbyRaceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports